import React from 'react';
import BannerNoInstalacion from '../../layouts/BannerNoInstalacion';

const IntroPisoSpcPremium = () => {
  return (
    <section className="spc-section spc-intro">
      <div className="container">
        <div className="row align-items-center">
          {/* Columna de texto */}
          <div className="col-lg-6 order-2 order-lg-1">
            <div className="mb-1-9 mb-lg-2-5 title-style5">
              <span className="sub-title">Pisos en tendencia 2026</span>
              <h2 className="display-5 lh-1 font-weight-800 mb-0">
                Piso SPC Luxury
              </h2>
            </div>
            <div className="mb-5">
              <p className="mb-1-6 mb-sm-2-2">
                El Piso SPC Luxury es un piso con apariencia de madera, mármol o piedra. Su base es muy firme (piedra y plástico), está diseñado para ofrecer la máxima durabilidad, estabilidad y estilo, no se deforma, ni se hincha con el agua, soporta rayones, alto tráfico y cambios de temperatura sin perder su estabilidad.
              </p>

              {/* Tarjetas */}
              <Tarjeta
                titulo="Ideal para diferentes ámbitos"
                descripcion="Hogares, oficinas y zonas comerciales de alto tráfico"
                delay="200ms"
              />
              <Tarjeta
                titulo="Sistema de ensamblado Unilin Click"
                descripcion="Asegura una instalación rápida, firme y duradera sin adhesivos"
                delay="400ms"
              />
              <Tarjeta
                titulo="Mayor precisión y estabilidad"
                descripcion="Evita aperturas y desplazamientos con el paso del tiempo."
                delay="600ms"
              />
            </div>
            <div className="w-xl-90 w-xxl-80 mb-6">
              <BannerNoInstalacion />
            </div>
            <a
              href="#catalogo"
              className="butn-style7 rounded wow fadeInUp"
              data-wow-delay="400ms"
            >
              VER CATÁLOGO
            </a>
          </div>

          {/* Columna de imagen */}
          <div className="col-lg-6 order-1 order-lg-2 mb-1-9 mb-lg-0">
            <div className="extra-style-01">
              <img
                className="rounded"
                src="/assets/img/productos/pisos-spc-premium/piso-spc-premium-intro.jpeg"
                alt="pisos spc luxury casa"
              />
              <div className="image-shape1">
                <img
                  className="d-none d-md-block"
                  src="/assets/img/productos/pisos-spc/piso-spc-lq6190-9-muestra.jpg"
                  alt="pisos spc sala"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

const Tarjeta = ({ titulo, descripcion, delay }) => (
  <div className="card card-style21 border-0 wow fadeInUp" data-wow-delay={delay}>
    <div className="d-flex">
      <span className="card-icon">
        <i className="fa-solid fa-check"></i>
      </span>
      <div className="card-content">
        <h5 className="card-title">{titulo}</h5>
        <p className="card-disc w-lg-85 w-xl-100">{descripcion}</p>
      </div>
    </div>
  </div>
);

export default IntroPisoSpcPremium;